module.exports = __webpack_public_path__ + "img/lead-12z.cb0f664d.png";